export default function PHP_Indexed_Arrays() {
  return (
    <div>
      <h1>PHP_Indexed_Arrays</h1>
    </div>
  );
}
